import * as actionTypes from '../types/infoMap';

const initialState = {
  mapData: [],
  loading: false,
  okRequest: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_MAP:
      return {
        ...state,
        mapData: [],
        loading: true,
        okRequest: false
      };

    case actionTypes.GET_MAP_SUCCESS:
      return {
        ...state,
        mapData: payload,
        loading: false,
        okRequest: true
      };

    case actionTypes.GET_MAP_FAIL:
      return {
        ...state,
        loading: false,
        okRequest: false
      };

    default:
      return state;
  }
};

export default reducer;
